import React from 'react';
import propTypes from 'prop-types';
import StarScore from '../../StarScore';
import HeaerBanner from './HeaderBanner';
import Tags from './Tags';

MainInfo.propTypes = {
  poi: propTypes.object.isRequired,
  tabType: propTypes.string.isRequired,
  poiType: propTypes.string.isRequired,
};



export default function MainInfo(props){
  let {poi, tabType, poiType, bannerVideo} = props;
  let {cn_name, en_name, lightspot} = poi.info;
  let { tag_list } = poi.attach_info;
  return(
    <div className="header-main">
      <div className="cn-name-wrap">
        {
          poi.reserve_info && poi.reserve_info.list.length ?
            <div className="order-sign"><span>订</span></div>
            : null
        }
        <h2 className="cn-name">{cn_name}</h2>
      </div>
      <p className="en-name">{en_name}</p>
      <HeaerBanner 
        pic={poi.info.pic}
        attachInfo={poi.attach_info} 
        name={cn_name} 
        tabType={tabType}
        bannerVideo={bannerVideo}/>
      {!!lightspot && 
        <div className="lightspot">
          <i className="icon icon-quot"></i>
          {lightspot}
          <i className="icon icon-quot rotate"></i>      
        </div>
      }
      <RankWrap {...poi.info} poiType={poiType}/>
      <Tags tagList={tag_list} />
    </div>
  );
}


/**
 * 评分模块
 * @param {*} props 
 * 非hotle类型 显示综合评分
 * 其他类型显示星星
 */
function RankWrap(props){
  let {poiType,level, average_grade, city_rank, price} = props;
  //if(poiType === 'attraction'){
  if(poiType !== 'hotel'){
    return(
      <section className="rank-wrap">
        <RankTitle rank={city_rank } poiType={poiType} />
        <RankTotal {...props} />
      </section>
    );
  }else{
    return(
      <section className="grade-wrap">
        <RankTitle rank={city_rank } poiType={poiType} level={level}/>
        <div className="grade-content">
          {
            price ? <p className="price"><strong>¥{price}</strong>起</p> : null
          }
          {
            price ? <span className="line"></span> : null
          }
          <strong className="grade-score">{average_grade}</strong>
          <StarScore score={average_grade/2} />
        </div>
      </section>
    );
  }
}


function RankTotal(props){
  let {average_grade, qyer_grade, mafengwo_grade} = props;
  if(Number(average_grade) > 0){
    return(
      <div className="rank-content">
        <div className="rank-total">
          <strong>{average_grade}</strong>
          <span>综合分</span>
        </div>
        <RankGrade source="穷游" grade={qyer_grade} />
        <span className="line"></span>
        <RankGrade source="蚂蜂窝" grade={mafengwo_grade} />
      </div>
    );
  }else{
    return null;
  }
}

const TYPE = {
  'attraction': '景点',
  'food': '美食',
  'shopping': '购物',
  'entertainment': '娱乐'
};
const LEVEL = {
  '1': '一',
  '2': '二',
  '3': '三',
  '4': '四',
  '5': '五'
};
function RankTitle(props){
  let { rank, poiType, level} = props;
  if(poiType === 'hotel' && LEVEL[level]){
    return <h4 className="rank-title">{LEVEL[level]}星级酒店</h4>;
  }else if(Number(rank)) {
    if(Number(rank) < 500 ){
      return <h4 className="rank-title">当地{TYPE[poiType]}人气排名第{rank}</h4>;
    }else{
      return <h4 className="rank-title">当地{TYPE[poiType]}人气排名500+</h4>;
    }
  }else{
    return null;
  }
}


function RankGrade(props){
  let { source, grade} = props;
  return(
    <div className="rank-qyer">
      {source} 
      { Number(grade) ?
        <strong>{grade}</strong> :
        <span>暂无</span>
      }
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/MainInfo.js